import React, { useState } from "react";
import { Box, Flex, Text, useColorModeValue, Container, HStack, Tag, Heading  } from "@chakra-ui/react";
import { useSelector } from "react-redux";

import TEMSeminarFr from "./TEMSeminarFr";
import TTESeminarFr from "./TTESeminarFr";


function TraversalSeminarHeader() {
  const accent = "#06B6D4";
  const accent2 = "#22D3EE";

  const border = useColorModeValue("rgba(2,6,23,0.10)", "rgba(148,163,184,0.18)");
  const titleColor = useColorModeValue("#0F172A", "white");
  const subColor = useColorModeValue("gray.700", "gray.300");

  const heroBg = useColorModeValue(
    "radial-gradient(1000px 420px at 12% 0%, rgba(6,182,212,0.18), transparent 60%), radial-gradient(900px 380px at 88% 25%, rgba(34,211,238,0.14), transparent 60%), linear-gradient(180deg, rgba(2,6,23,0.02), rgba(2,6,23,0.00))",
    "radial-gradient(1000px 420px at 12% 0%, rgba(6,182,212,0.20), transparent 60%), radial-gradient(900px 380px at 88% 25%, rgba(34,211,238,0.14), transparent 60%), linear-gradient(180deg, rgba(255,255,255,0.03), rgba(255,255,255,0.00))"
  );

  return (
    <Box
      pt={{ base: 6, md: 8 }}
      pb={{ base: 8, md: 10 }}
      bg={heroBg}
      borderBottom="1px solid"
      borderColor={border}
    >
      <Container maxW="1200px">
        <HStack spacing={2}>
          <Tag
            size="lg"
            borderRadius="full"
            bg={useColorModeValue("white", "rgba(255,255,255,0.06)")}
            border="1px solid"
            borderColor={border}
            fontWeight="800"
          >
            University of Ottawa
          </Tag>

          <Tag
            size="lg"
            borderRadius="full"
            bg={useColorModeValue("rgba(6,182,212,0.12)", "rgba(6,182,212,0.18)")}
            color={useColorModeValue("#0E7490", "#67E8F9")}
            fontWeight="900"
          >
            TRAVERSAL
          </Tag>
        </HStack>

        <Heading
          mt={4}
          fontSize={{ base: "3xl", md: "4xl" }}
          color={titleColor}
          letterSpacing="tight"
        >
          <Box
            as="span"
            bgClip="text"
            bgGradient={`linear(to-r, ${accent}, ${accent2})`}
          >
            TRAVERSAL
          </Box>{" "}
          Séminaires 
        </Heading>

        <Text
          mt={3}
          color={subColor}
          fontSize={{ base: "md", md: "lg" }}
          maxW="85ch"
          lineHeight={1.8}
        >
          Les séminaires TRAVERSAL aborderont un large éventail de sujets, y compris les développements de pointe dans divers domaines 
          de la recherche, le transfert de technologie et l'entrepreneuriat. Avec la participation de conférenciers éminents du monde entier, 
          les séminaires offrent une occasion unique de partage de connaissances, de collaboration et de réseautage.
        </Text>
      </Container>
    </Box>
  );
}


function Technical() {
  const isMobile = useSelector((state) => state.windowSize.isMobile);
  const [active, setActive] = useState("TEM");

  const contentAlign = isMobile ? "center" : "left";

  return (
    <>
      <TraversalSeminarHeader />

      <Box maxW="1200px" mx="auto" px={isMobile ? 4 : 0} pt={isMobile ? 2 : 4} pb={12}>
        {/* -------- Segmented Toggle (small visual upgrade) -------- */}
        <Flex
          w="100%"
          mb={6}
          p="6px"
          border="1px solid"
          borderColor="rgba(0,0,0,0.12)"
          borderRadius="full"
          bg="rgba(0,0,0,0.03)"
          gap="6px"
          flexDir={{ base: "column", md: "row" }} // better on mobile
        >
          <Flex
            flex="1"
            justify="center"
            align="center"
            textAlign="center"
            px={4}
            py={3}
            cursor="pointer"
            fontWeight="700"
            borderRadius="full"
            bg={active === "TEM" ? "white" : "transparent"}
            boxShadow={active === "TEM" ? "0 6px 18px rgba(0,0,0,0.10)" : "none"}
            transition="all 180ms ease"
            onClick={() => setActive("TEM")}
          >
            SÉRIE DE SÉMINAIRES DE MENTORAT TECHNIQUE-ÉTHIQUE
          </Flex>

          <Flex
            flex="1"
            justify="center"
            align="center"
            textAlign="center"
            px={4}
            py={3}
            cursor="pointer"
            fontWeight="700"
            borderRadius="full"
            bg={active === "TTE" ? "white" : "transparent"}
            boxShadow={active === "TTE" ? "0 6px 18px rgba(0,0,0,0.10)" : "none"}
            transition="all 180ms ease"
            onClick={() => setActive("TTE")}
          >
            ENTREPRENEURIAT EN TRANSFERT DE TECHNOLOGIE
          </Flex>
        </Flex>

        {/* -------- Content (small visual upgrade) -------- */}
        {active === "TEM" ? (
          <>
            <Box
              borderRadius="16px"
              p={isMobile ? 4 : 6}
              mb={6}
              bg="white"
              border="1px solid"
              borderColor="rgba(0,0,0,0.08)"
              boxShadow="0 10px 24px rgba(0,0,0,0.06)"
            >
              <Text fontSize="2xl" fontWeight="bold" textAlign="center" mb={3}>
                SÉRIE DE SÉMINAIRES DE MENTORAT TECHNIQUE-ÉTHIQUE
              </Text>

              <Text textAlign={contentAlign} lineHeight="1.8" color="gray.700">
                <b>La Série de Séminaires de Mentorat Technique-Éthique,</b>, abrégée sous le nom de TEM, est un élément essentiel du programme 
                TRAVERSAL. Cette série offre aux stagiaires des informations précieuses sur les dernières avancées techniques dans le domaine 
                des véhicules autonomes (VA) et des véhicules aériens sans équipage (UAV). De plus, TEM aborde les dimensions légales et éthiques 
                associées aux services basés sur les VA et les UAV. Elle comprend un minimum de huit séminaires par an, garantissant que les 
                stagiaires acquièrent des connaissances complètes et des orientations à la fois techniques et éthiques dans leur domaine. Grâce 
                à TEM, les stagiaires acquièrent une compréhension globale du paysage complexe et en évolution des technologies des VA et des UAV.
              </Text>
            </Box>

            <TEMSeminarFr />
          </>
        ) : (
          <>
            <Box
              borderRadius="16px"
              p={isMobile ? 4 : 6}
              mb={6}
              bg="white"
              border="1px solid"
              borderColor="rgba(0,0,0,0.08)"
              boxShadow="0 10px 24px rgba(0,0,0,0.06)"
            >
              <Text fontSize="2xl" fontWeight="bold" textAlign="center" mb={3}>
                ENTREPRENEURIAT EN TRANSFERT DE TECHNOLOGIE
              </Text>

              <Text textAlign={contentAlign} lineHeight="1.8" color="gray.700">
                L'aspect de l'<b>Entrepreneuriat en Transfert de Technologie</b> du programme TRAVERSAL se concentre sur l'équipement des stagiaires 
                avec les connaissances et les compétences nécessaires pour la réussite de la préparation technologique et de la commercialisation. 
                Ce segment propose des stratégies pour transformer les résultats de la recherche du programme en produits ou services commerciaux 
                viables. Les stagiaires bénéficient du soutien en séminaire grâce aux bureaux de transfert de technologie et profitent de 
                l'expertise d'anciens diplômés des accélérateurs de start-up. Pour garantir une formation complète, les stagiaires doivent 
                assister à un minimum de quatre séminaires dans chaque filière par an. Cette emphase sur le transfert de technologie et 
                l'entrepreneuriat permet aux stagiaires de naviguer efficacement dans le parcours de la recherche aux applications réelles, 
                favorisant ainsi l'innovation et l'impact économique.
              </Text>
            </Box>

            <TTESeminarFr />
          </>
        )}
      </Box>
    </>
  );
}


export default Technical;
